export default "__VITE_ASSET__m1IcLCi5__"